import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-12 text-center">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">常见问答</h2>
          <p className="text-sm md:text-base text-foreground-400">关于吃瓜视频，你可能想了解的问题</p>
        </div>

        <div className="space-y-4">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-100 border border-background-200/60 p-5 md:p-6"
            >
              <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center mt-0.5">
                  <span className="text-xs font-bold text-primary-500">Q</span>
                </span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-9">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}